var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md:border-none border-b border-background-100 md:pb-0 pb-4",class:_vm.bodyClass},[_c('div',{staticClass:"w-full load-anim bg-gray-300 h-full"})])}
var staticRenderFns = []

export { render, staticRenderFns }